<form class="f-col blank-form" [formGroup]="SaveCardForm">
  <div class="section-heading">
    <h2 class="h2-heading">
      {{content?.['b2b.managetraveler.savedcards']}}
      <div class="dot">.</div>
      <span class="optional">{{content?.['b2b.managetraveler.optional']}}</span>
    </h2>
    <a role="button" class="link" *ngIf="dataSource1.data.length > 0 && !Addnew && isTAEditMode"
      (click)="handleEvent('saved-cards')"><mat-icon fontSet="material-symbols-outlined"
        class="add-icon">add</mat-icon>
      {{content?.['b2b.managetraveler.addnewcard'] || 'Add new card'}}</a>
  </div>

  <div class="section-content" *ngIf="dataSource1.data.length > 0 || Addnew">
    <div class="inner-contentsection">
      <div *ngIf="!dataSource1.data.length || Addnew" class="f-col form-listing">
        <input type="hidden" formControlName="guid" />
        <div class="f-row">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managetraveler.cardnameopt']}}</mat-label>
              <input matInput formControlName="cardName" (keypress)="_CommonService.blockSpecialChar($event)"
                (paste)="_CommonService.onPasteBlocked($event)" (contextmenu)="_CommonService.disableRightClick($event)"
                data-dd-privacy="mask" />
              <!-- Error handling for card Name form control -->
              <mat-error *ngIf="
                  SaveCardForm.get('cardName')?.hasError('required') &&
                  SaveCardForm.get('cardName')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardnamereq']}}
              </mat-error>
              <!-- Invalid Format Error (Single-letter word restriction) -->
              <mat-error *ngIf="
                  SaveCardForm.get('cardName')?.hasError('minlength') &&
                  SaveCardForm.get('cardName')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardnameminlimit']}}
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardName')?.hasError('maxlength') &&
                  SaveCardForm.get('cardName')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardnamemaxlimit']}}
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardName')?.hasError(
                    'noHtmlTagsValidator'
                  ) && SaveCardForm.get('cardName')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardnamenotinclude']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managetraveler.cardoption']}}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
              <mat-select formControlName="cardOption" aria-readonly="true" data-dd-privacy="mask">
                <mat-option *ngFor="let type of Cardoption" [value]="type.PayMode_Name">
                  {{ type.PayMode_Name }}
                </mat-option>
              </mat-select>
              <!-- Error handling for cardOption form control -->
              <mat-error *ngIf="
                  SaveCardForm.get('cardOption')?.hasError('required') &&
                  SaveCardForm.get('cardOption')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardoptionreq']}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managetraveler.cardtype']}}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
              <mat-select formControlName="cardType" aria-readonly="true" (selectionChange)="setCarNumberNull()"
                data-dd-privacy="mask">
                <mat-option *ngFor="let type of CardTypes" [value]="type.Card_Code">
                  {{ type.Card_Name }}
                </mat-option>
              </mat-select>
              <!-- Error handling for card Type form control -->
              <mat-error *ngIf="
                  SaveCardForm.get('cardType')?.hasError('required') &&
                  SaveCardForm.get('cardType')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardtypereq']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managetraveler.cardholdername']}}</mat-label>
              <input matInput formControlName="cardHolderName" (keypress)="blockDigits($event)"
                (paste)="_CommonService.onPasteBlocked($event)" (contextmenu)="_CommonService.disableRightClick($event)"
                data-dd-privacy="mask" />
              <!-- Error handling for card Holder Name form control -->
              <mat-error *ngIf="
                  SaveCardForm.get('cardHolderName')?.hasError('required') &&
                  SaveCardForm.get('cardHolderName')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardholdernamereq']}}
              </mat-error>
              <!-- Invalid Format Error (Single-letter word restriction) -->
              <mat-error *ngIf="SaveCardForm.get('cardHolderName')?.hasError('pattern')">
                {{content?.dictionary?.['b2b.managetraveler.cardholdernamecontains']}}
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardHolderName')?.hasError('minlength') &&
                  SaveCardForm.get('cardHolderName')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardholdernameminlimit']}}
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardHolderName')?.hasError('maxlength') &&
                  SaveCardForm.get('cardHolderName')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardholdernamemaxlimit']}}
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardHolderName')?.hasError(
                    'noHtmlTagsValidator'
                  ) && SaveCardForm.get('cardHolderName')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardholdernamenotinclude']}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managetraveler.cardnumber']}}</mat-label>
              <input matInput formControlName="cardNumber" (keypress)="numberValidator($event)"
                [value]="SaveCardForm.get('cardNumber')?.value | cardNumberFormat"
                (paste)="_CommonService.onPasteBlocked($event)" (contextmenu)="_CommonService.disableRightClick($event)"
                [errorStateMatcher]="matcher" data-dd-privacy="mask" />
              <mat-error *ngIf="
                  SaveCardForm.get('cardNumber')?.hasError('required') &&
                  SaveCardForm.get('cardNumber')?.touched
                ">
                {{content?.dictionary?.['b2b.managecompany.cardnumberreq']}}
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardNumber')?.hasError('minlength') &&
                  SaveCardForm.get('cardNumber')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.cardnominlimit'] || 'Card number must be at least 13
                digits.'}}
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardNumber')?.hasError('maxlength') &&
                  SaveCardForm.get('cardNumber')?.touched
                ">
                Card Number cannot exceed more than 19 digit.
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardNumber')?.hasError('pattern') &&
                  SaveCardForm.get('cardNumber')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.onlynumbersallowed']}}
              </mat-error>
              <mat-error *ngIf="
                  SaveCardForm.get('cardNumber')?.hasError('invalidCard') &&
                  (SaveCardForm.get('cardNumber')?.touched || SaveCardForm.get('cardNumber')?.dirty)
                ">
                {{content?.dictionary?.['b2b.managetraveler.entervalidcardno'] || 'Please Enter a valid card Number.'}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row two--ColLayout">
          <div class="f-col">
            <mat-form-field>
              <mat-label>{{content?.['b2b.managetraveler.expiryyear']}}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
              <mat-select formControlName="expiryMonth" aria-readonly="true" (selectionChange)="checkPastMonth()"
                data-dd-privacy="mask">
                <mat-option *ngFor="let month of months" [value]="month.value">
                  {{ month.name }}
                </mat-option>
              </mat-select>
              <!-- Error handling for expiryMonth form control -->
              <mat-error *ngIf="
                  SaveCardForm.get('expiryMonth')?.hasError('required') &&
                  SaveCardForm.get('expiryMonth')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.expirymonthreq']}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="f-col">
            <mat-form-field>
              <mat-label>{{companyManagementContent?.['b2b.managecompany.ccselexpiryyear'] || 'Expiry Year'}}</mat-label>
              <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
              <mat-select formControlName="expiryYear" data-dd-privacy="mask">
                <mat-option *ngFor="let year of years" [value]="year.value">
                  {{ year.value }}
                </mat-option>
              </mat-select>
              <!-- Error handling for expiryYear form control -->
              <mat-error *ngIf="
                  SaveCardForm.get('expiryYear')?.hasError('required') &&
                  SaveCardForm.get('expiryYear')?.touched
                ">
                {{content?.dictionary?.['b2b.managetraveler.expiryyearreq']}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="f-row">
          <div class="f-col">
            <div class="f-row validation-col">
              <mat-label class="mat-label">{{content?.['b2b.managetraveler.saveas']}}</mat-label>
              <mat-radio-group name="saves" aria-label="Select an option" formControlName="saveCardAs"
                data-dd-privacy="mask">
                <mat-radio-button value="1" checked>{{content?.['b2b.managetraveler.personalcard']}}</mat-radio-button>
                <mat-radio-button value="2">{{content?.['b2b.managetraveler.corporatecard']}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="dataSource1.data.length > 0 && !Addnew" class="section-table data-listing">
        <table mat-table [dataSource]="dataSource1" class="mat-elevation-z0">
          <!-- Card Name Column -->
          <ng-container matColumnDef="Card_Name">
            <th mat-header-cell *matHeaderCellDef>
              {{content?.['b2b.managetraveler.cardname']}}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.Card_Name }}</td>
          </ng-container>

          <!-- Card Option Column -->
          <ng-container matColumnDef="Card_option">
            <th mat-header-cell *matHeaderCellDef>
              {{content?.['b2b.managetraveler.cardoption']}}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
              {{ element.Card_Option }}
            </td>
          </ng-container>

          <ng-container matColumnDef="Card_Type">
            <th mat-header-cell *matHeaderCellDef>
              {{content?.['b2b.managetraveler.cardtype']}}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.Card_Type }}</td>
          </ng-container>

          <!-- Holder Name Column -->
          <ng-container matColumnDef="Holder_Name">
            <th mat-header-cell *matHeaderCellDef>
              {{content?.['b2b.managetraveler.holdername']}}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
              {{ element.Name_on_Card }}
            </td>
          </ng-container>

          <ng-container matColumnDef="Card_Number">
            <th mat-header-cell *matHeaderCellDef>
              {{content?.['b2b.managetraveler.cardnumber']}}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">
              {{ maskCardNumber(element.Card_Number) }}
            </td>
          </ng-container>
          <!-- Expiry Date Column -->
          <ng-container matColumnDef="CardExpiry">
            <th mat-header-cell *matHeaderCellDef>
              {{content?.['b2b.managetraveler.expirydate']}}
            </th>
            <td mat-cell *matCellDef="let element" data-dd-privacy="mask">{{ element.CardExpiry }}</td>
          </ng-container>
          <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef>
              {{content?.['b2b.managetraveler.actions']}}
            </th>
            <td mat-cell *matCellDef="let element" class="onclick-links">
              <a class="onclick-cell warm-link" *ngIf="!Addnew && isTAEditMode" (click)="deleteThisCard(element.CardID)">
                {{content?.['b2b.managetraveler.remove']}}
              </a>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns1"></tr>
        </table>
      </div>
    </div>

    <div class="inner-action" *ngIf="Addnew">
      <button type="button" mat-button class="button--secondary-small" (click)="Cancel()">
        {{content?.['b2b.managetraveler.cancel']}}
      </button>
      <button type="button" mat-button class="button--primary-small"
        [class.disabled]="SaveCardForm.invalid || noDataPersonalInfo" (click)="addUpdateCardDetails()">
        <mat-spinner class="button" *ngIf="Loader.isSpinner"></mat-spinner>{{content?.['b2b.managetraveler.save']}}
      </button>
    </div>
  </div>
  <ng-container *ngIf="dataSource1.data.length == 0 && !Addnew">
    <app-cam-empty-state (myEvent)="handleEvent($event)"
      [heading]="content?.['b2b.managetraveler.nosavedcardstitle']"
      [content]="content?.['b2b.managetraveler.nosavedcardsdesc']" [navigateTo]="'/saved-cards'"
      [isProfileViewRestricted]="!isTAEditMode">
    </app-cam-empty-state>
  </ng-container>
</form>

<ng-template #selectionWarning>
  <div class="custom-dialog">
    <div class="d-justify-bw">
      <div class="custom-dialog__left">
        <div class="mat-dialog-title custom-dialog__title d-justify-bw">
          <h2 class="mat-dialog-title"> {{content?.['b2b.managetraveler.confirmchanges'] || 'Confirm changes'}}</h2>
          <!-- <div class="custom-overlay-close">
                      <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                  </div> -->
        </div>
        <mat-dialog-content class="custom-dialog__text">
          <div class="custom-dialog__description">{{content?.['b2b.managetraveler.wantremovesavedcard'] || 'Are you sure
            you want to remove this Saved Card?'}}</div>
        </mat-dialog-content>
        <mat-dialog-actions>
          <div class="dialog-actions-right ml-auto px-6">
            <button class="button--secondary-small" mat-button
              (click)="CloseDialog(false)">{{content?.['b2b.managetraveler.cancel'] || 'Cancel'}}</button>
            <button class="button--primary-small confirmBtn" mat-button
              (click)="CloseDialog(true)">{{content?.['b2b.managetraveler.confirm'] || 'Confirm'}}</button>
          </div>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</ng-template>